import { createRoot } from 'react-dom/client';

import { CartWrapper } from './CartWrapper';
import Cart from './components/cart/cart';
import type { ShoppingCartProviderProps } from './context/CartContext';

export const renderCart = (cartId: string, props: Omit<ShoppingCartProviderProps, 'children'>) => {
    const cartContainer = document.getElementById(cartId);

    if (!cartContainer) {
        return null;
    }

    createRoot(cartContainer).render(
        <CartWrapper props={props}>
            <Cart />
        </CartWrapper>,
    );
};
